import dayjs from 'dayjs'
import xhr from 'xhr'

// Pagos que cuentan como pago real del estudiante.
const PAID_STATUSES = ['approved', 'factured']

const inFilter = (field, ids) => ids.map((id, index) => `filters${field}[$in][${index}]=${id}`).join('&')

/**
 * Primer pago de los estudiantes de cada prospecto (vínculo prospecto →
 * estudiante creado o vinculado desde asesoras). Devuelve
 * { [prospectId]: { firstPaymentDate, daysToClose, hasStudents } }.
 * Los prospectos sin estudiante vinculado no aparecen.
 */
export async function loadClosingInfo(prospects) {
  const prospectIds = prospects.map((el) => el.id)
  if (!prospectIds.length) return {}

  const resStudents = await xhr(
    `/students?${inFilter('[origin_prospect][id]', prospectIds)}&fields[0]=id&populate[origin_prospect][fields][0]=id&pagination[pageSize]=100`
  )
  const prospectByStudent = {}
  resStudents.data.data.forEach((student) => {
    if (student.origin_prospect?.id) prospectByStudent[student.id] = student.origin_prospect.id
  })
  const studentIds = Object.keys(prospectByStudent)
  if (!studentIds.length) return {}

  const result = Object.fromEntries(
    [...new Set(Object.values(prospectByStudent))].map((id) => [
      id,
      { hasStudents: true, firstPaymentDate: null, daysToClose: null },
    ])
  )

  const resPayments = await xhr(
    `/payments?${inFilter('[student][id]', studentIds)}&${PAID_STATUSES.map((status, index) => `filters[status][$in][${index}]=${status}`).join('&')}` +
      `&fields[0]=payment_date&fields[1]=createdAt&populate[student][fields][0]=id&pagination[pageSize]=250`
  )
  resPayments.data.data.forEach((payment) => {
    const prospectId = prospectByStudent[payment.student?.id]
    const date = payment.payment_date || payment.createdAt
    if (!prospectId || !date) return
    const current = result[prospectId].firstPaymentDate
    if (!current || dayjs(date).isBefore(current)) result[prospectId].firstPaymentDate = date
  })

  // Desde la fecha en que el contacto escribió (la anota la asesora) o, si no hay, desde su registro.
  const createdAt = Object.fromEntries(prospects.map((el) => [el.id, el.contact_date || el.createdAt]))
  Object.entries(result).forEach(([prospectId, info]) => {
    if (!info.firstPaymentDate) return
    info.daysToClose = Math.max(
      0,
      dayjs(info.firstPaymentDate).startOf('day').diff(dayjs(createdAt[prospectId]).startOf('day'), 'day')
    )
  })
  return result
}

export const formatDays = (days) => (days === 1 ? '1 día' : `${days} días`)
